import { Directive, Input, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
	selector: '[autofocus]',
})
export class AutoFocusDirective implements AfterViewInit {
	private shouldFocus = true;

	@Input('autofocus')
	set autoFocus(shouldFocus: boolean) {
		this.shouldFocus = shouldFocus;
		this.checkFocus();
	}

	constructor(
		private readonly elementRef: ElementRef<HTMLElement>
	) {
	}

	ngAfterViewInit() {
		this.checkFocus();
	}

	private checkFocus() {
		if (!this.shouldFocus) {
			return;
		}

		if (!this.elementRef.nativeElement) {
			return;
		}

		let focusableElements = ['input', 'textarea', 'select', 'button', 'a']

		if (focusableElements.includes(this.elementRef.nativeElement.tagName.toLowerCase())) {
			this.elementRef.nativeElement.focus?.();
			return;
		}

		for (let tagName of focusableElements) {
			let childElement = this.elementRef.nativeElement.querySelector<HTMLElement>(tagName)

			if (childElement) {
				childElement?.focus?.();
				return;
			}
		}
	}
}
